import { FilterStep } from '@warehouse/shared/filters';
import { editUuid, episodeUuid, manifestationUuid, supplementalUuid } from '../infra';

export const defaultFilters: FilterStep = {
	step: {
		combinationOperator: 'AND',
		filters: [
			{
				field: 'titleStatus',
				operator: 'doesNotEqual',
				value: 'hidden',
			},
			{
				step: {
					filters: [
						{
							field: 'workType.uuid',
							operator: 'doesNotEqual',
							value: editUuid(),
						},
						{
							field: 'workType.uuid',
							operator: 'doesNotEqual',
							value: manifestationUuid(),
						},
						{
							field: 'workType.uuid',
							operator: 'doesNotEqual',
							value: supplementalUuid(),
						},
						{
							field: 'workType.uuid',
							operator: 'doesNotEqual',
							value: episodeUuid(),
						},
					],
					combinationOperator: 'AND',
				},
			},
		],
	},
};
